import React from 'react';
import { motion } from 'framer-motion';
import { Star, StarIcon } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
const testimonials = [{
  quote: 'Pensé que nunca iba a volver a ver mi cara como la tengo hoy en día...',
  author: 'Maria R.'
}, {
  quote: 'Kate ha sanado mi piel de tantas maneras. Es muy raro encontrar una esteticista que genuinamente se preocupe por tu proceso.',
  author: 'Ana E.'
}, {
  quote: 'Llegué con un acné super alborotado y descontrolado. Quedé súper encantada.',
  author: 'Yolyney A.'
}];
export function TestimonialsSection() {
  const {
    t
  } = useLanguage();
  return <section id="resenas" className="py-12 md:py-24 bg-brand-white relative border-t border-brand-gold/10" data-id="element-462" data-mp="142r4qdz9vaa7">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-463" data-mp="1831kgicv9f29">
        <motion.div initial={{
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.15
      }} transition={{
        duration: 0.6
      }} data-id="element-464" data-mp="2yg8tu5fbsf7c">
          <p className="text-sm uppercase tracking-widest text-brand-gold font-semibold mb-8 text-center" data-id="element-465" data-mp="2uzhs1cger2du">
            {t('testimonials.subtitle')}
          </p>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-466" data-mp="34qcf2j1ha60c">
            {testimonials.map((testimonial, index) => <div key={index} className="bg-brand-cream p-8 rounded-sm shadow-sm border border-brand-gold/5 relative flex flex-col" data-id="element-467" data-mp="2ztlylulrh8ee" data-mpi={index}>
                <div className="flex mb-4 text-brand-gold" data-id="element-468" data-mp="2c4jkgwqc5xon">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-469" data-mp="275q7d5eyo8p0" data-mpi={i} />)}
                </div>
                <p className="text-brand-charcoal italic mb-4 flex-1" data-id="element-470" data-mp="2m27ibvj8nlb1">
                  "{testimonial.quote}"
                </p>
                <p className="font-semibold text-brand-brown" data-id="element-471" data-mp="1anf1u821p9i">
                  — {testimonial.author}
                </p>
              </div>)}
          </div>

          <p className="text-center text-brand-charcoal font-medium mt-10 max-w-2xl mx-auto" data-id="element-472" data-mp="3sggfyina7rnn">
            {t('testimonials.footer')}
          </p>

          <div className="text-center mt-6" data-id="element-473" data-mp="8dlm4viqp88s">
            <a href="https://share.google/aeNeaqJ9AadTchr2e" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-sm font-medium text-brand-gold hover:text-brand-gold-light transition-colors border border-brand-gold/30 px-4 py-2 rounded-sm" data-id="element-474" data-mp="8cagsr9nbsfk">
              <StarIcon className="w-4 h-4 fill-current" data-id="element-475" data-mp="3guq6tbafhthh" />
              {t('testimonials.button')}
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}